module.exports = __webpack_public_path__ + "media/svg/emptystate-kota-524e1a96.svg";